import React, { useEffect } from "react";
import { checkAuthAndRedirect } from "../../../utils/auth";
import ViolationPolicyTable from "./ViolationPolicyTable";

const TestViolationPolicies: React.FC = () => {
  useEffect(() => {
    checkAuthAndRedirect();
  }, []);

  return (
    <div
      className="border rounded-2 bg-white my-2 me-2 d-flex flex-column"
      style={{ height: "calc(100vh - 88px)", overflow: "hidden" }}
    >
      <div className="flex-grow-1 overflow-auto p-3">
        <ViolationPolicyTable />
      </div>
    </div>
  );
};

export default TestViolationPolicies;
